import React, { useEffect, useRef } from 'react'

import { i18nText } from '../../../Services'

export const Checkbox = props => {
    const { context, defaultValue, element, modelPath } = props;
    const inputModel = context.readModel(modelPath, defaultValue || element.defaultValue || false);    
    const checked = inputModel.value ? ("" + inputModel.value).toLowerCase() === "true" ? true : false : false;

    let inputRef = useRef(null);

    const change = () => {
        const errors = context.validateElement(inputRef.current, element, inputRef.current.checked);
        context.updateModel(modelPath, inputRef.current.checked, errors);
    }

    useEffect(() => {
        context.validators.subscribe(change);
        return () => context.validators.unsubscribe(change);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context, element, modelPath, inputRef]);

    return (
        <div className="custom-control custom-checkbox">
            <input
                type="checkbox"
                ref={inputRef}
                autoComplete="off"
                className={"custom-control-input" + (inputModel.errors.length !== 0 ? " is-invalid" : "") + (element.className ? " " + element.className : "")}
                disabled={context.isReadOnly}
                id={element.name}
                name={`${element.name}-${modelPath}`}
                onBlur={change}
                onChange={change}
                onFocus={change}
                required={element.required}
                checked={checked}
            />            
            { i18nText.exists(element.text) && <label className="custom-control-label" htmlFor={element.name}>{i18nText.getText(element.text)}{element.required && <span className="asterisk"> *</span>}</label> }
        </div>
    )
}

export default Checkbox;